module.exports = __webpack_public_path__ + "img/W.731531c8.jpg";